import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_TIRE_EDIT_FORM_SCHEMA = yup.object().shape({
  width: yup.string().required("Molimo Vas da unesite širinu gume"),
  height: yup.string().required("Molimo Vas da unesite visinu gume"),
  radius: yup.string().required("Molimo Vas da unesite promjer gume"),
  changePrice: yup
    .string()
    .required("Molimo Vas da unesite trošak zamjene guma"),
  hotelPrice: yup
    .string()
    .required("Molimo Vas da unesite cijenu čuvanja guma"),
});
